import * as React from 'react';
const ColpoDellaStregaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <ellipse
      cx={125.46}
      cy={65.29}
      className="prefix__cls-2"
      rx={8.54}
      ry={8.25}
    />
    <path
      d="M118.62 82.22c0 .13-.01.25-.04.38-.73 6.36.22 13.73 2.81 21.93.65 2.05-.55 4.24-2.69 4.85-.32.12-.69.16-1.02.18-1.78.06-3.46-1.04-4.01-2.76-1.94-6.12-3.5-15.53-3.77-20.9M106.99 68.31c-.07-.03-.12-.04-.19-.07l-16.83-5.46a4.2 4.2 0 0 0-3.15.23c-.97.49-1.7 1.34-2.01 2.35l-4.69 15.2c-.63 2.05.58 4.22 2.72 4.85.26.06.51.12.77.14 1.88.17 3.7-.96 4.25-2.77l3.49-11.33 9.64 3.12M101 74.59c-8.87 9.88-16.79 17.46-15.28 25.37s14.81 15.75 14.81 15.75l-8.18 21.45c-.97 2.17.19 4.63 2.6 5.5.58.2 1.18.31 1.78.31 1.86 0 3.62-1 4.36-2.64l11.11-24.62c1.37-2.92-4.55-9.82-7.49-12.98a3.18 3.18 0 0 1-.47-3.68l5.67-8.87"
      className="prefix__cls-2"
    />
    <path
      d="M118.58 82.59c.03-.13.04-.25.04-.38.63-6.14-4.79-11.7-11.63-13.91-.07-.03-.12-.04-.19-.07"
      className="prefix__cls-2"
    />
    <path
      d="M91.06 97.08s.84-4.54 5.5-9.13M66 86.58l8.34 5.98 1.08-5.57 6.02 4.32"
      className="prefix__cls-1"
    />
  </svg>
);
export default ColpoDellaStregaIcon;
